// Libraries
import { useQuery } from "@apollo/client";
// API
import { GET_BU_ANIMAL_BREEDS } from "api/MyLivestock/Animal/queries";
import {
  GetBusinessUnitBreeds,
  GetBusinessUnitBreedsVariables,
  GetBusinessUnitBreeds_businessUnitBreeds,
} from "api/MyLivestock/Animal/types/GetBusinessUnitBreeds";
// Utils
import { getBUFromLocalStorage } from "helpers/storage";
import { useStateSpecies } from "./useStateSpecies";
interface UseGetBreedsParams {
  forAllSpecies?: boolean;
}

export const useGetBreeds = ({ forAllSpecies }: UseGetBreedsParams = {}) => {
  const { active: speciesActive } = useStateSpecies();

  const { data, ...rest } = useQuery<GetBusinessUnitBreeds, GetBusinessUnitBreedsVariables>(GET_BU_ANIMAL_BREEDS, {
    variables: {
      businessUnitId: getBUFromLocalStorage(),
      animalTypeIds: !forAllSpecies && speciesActive ? [+speciesActive.id] : null,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const breeds = (data?.businessUnitBreeds || []) as GetBusinessUnitBreeds_businessUnitBreeds[];

  return {
    data: breeds,
    ...rest,
  };
};
